import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HiOutlineHome, HiOutlineShoppingCart, HiOutlineLocationMarker, HiHome, HiShoppingCart, HiOutlineLink } from 'react-icons/hi';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cartItems = useSelector((state) => state.cart.cart);
  const { profile } = useSelector((state) => state.profile);
  
  // Calculate total cart items
  const totalCartItems = cartItems ? cartItems.reduce((total, item) => total + (item.quantity || 0), 0) : 0;

  const handleConnect = () => {
    navigate('/connect');
  };

  const handleMap = () => {
    window.open(profile?.map_url , "_blank");
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-xl">
      <div className="flex items-center justify-around py-3 px-2">
        {/* Home Tab */}
        <button
          onClick={() => navigate('/')}
          className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all duration-300 ${
            isActive('/') 
              ? 'text-primary bg-red-100' 
              : 'text-gray-600 hover:text-primary hover:bg-gray-50'
          }`}
        >
          {isActive('/') ? (
            <HiHome className="w-6 h-6 mb-1 transition-all duration-300 scale-110" />
          ) : (
            <HiOutlineHome className="w-6 h-6 mb-1 transition-all duration-300" />
          )}
          <span className="text-xs font-semibold">Home</span>
        </button>

        {/* Cart Tab */}
        <button
          onClick={() => navigate('/orders')}
          className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all duration-300 relative ${
            isActive('/orders') 
              ? 'text-primary bg-red-100' 
              : 'text-gray-600 hover:text-primary hover:bg-gray-50'
          }`}
        >
          {isActive('/orders') ? (
            <HiShoppingCart className="w-6 h-6 mb-1 transition-all duration-300 scale-110" />
          ) : (
            <HiOutlineShoppingCart className="w-6 h-6 mb-1 transition-all duration-300" />
          )}
          <span className="text-xs font-semibold">Cart</span>
          {totalCartItems > 0 && (
            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-lg border-2 border-white animate-pulse">
              {totalCartItems > 99 ? '99+' : totalCartItems}
            </div>
          )}
        </button>

        {/* Connect Tab */}
        <button
          onClick={handleConnect}
          className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all duration-300 ${
            isActive('/connect') 
              ? 'text-purple-600 bg-purple-100' 
              : 'text-gray-600 hover:text-purple-600 hover:bg-purple-50'
          }`}
        >
          <HiOutlineLink className="w-6 h-6 mb-1 transition-all duration-300" />
          <span className="text-xs font-semibold">Connect</span>
        </button>

        {/* Map Tab */}
        <button
          onClick={handleMap}
          className="flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all duration-300 text-gray-600 hover:text-blue-600 hover:bg-blue-50"
        >
          <HiOutlineLocationMarker className="w-6 h-6 mb-1 transition-all duration-300" />
          <span className="text-xs font-semibold">Map</span>
        </button>
      </div>
    </div>
  );
};

export default MobileBottomNav;

